import { GzCopyToClipboardWebComponent } from './component/GzCopyToClipboardWebComponent';
import { WEB_COMPONENT_GZ_COPY_TO_CLIPBOARD } from '../../webcomponents.constants';

export { GzCopyToClipboardWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_COPY_TO_CLIPBOARD, GzCopyToClipboardWebComponent);
